import * as React from 'react';

import { cn } from '../../utils/cn/cn';

interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  /**
   * The id of the input element the label is associated with.
   */
  htmlFor: string;
}

const Label: React.FC<LabelProps> = ({ htmlFor, className, children, ...props }) => (
  <label
    {...props}
    htmlFor={htmlFor}
    className={cn(
      'text-size-body-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-35',
      className,
    )}
  >
    {children}
  </label>
);

export { Label };
